﻿define(['Handlebars', 'text!userSearchGridTemplate', 'text!userSearchGridInternalPartial', 'text!userSearchGridExternalPartial',
	'text!userSearchGridGenericPartial', 'text!connectButtonPartial', 'text!sendMessageButtonPartial', 'text!userSearchGridNoResultsPartial', 'text!sendReferralButtonPartial', 'text!userSearchfeaturedpremiumPartial'],

	function (Handlebars, userSearchGridTemplate, userSearchGridInternalPartial, userSearchGridExternalPartial,
		userSearchGridGenericPartial, connectButtonPartial, sendMessageButtonPartial, userSearchGridNoResultsPartial, sendReferralButtonPartial, userSearchfeaturedpremiumPartial) {
		'use strict';
		Handlebars.registerPartial('userSearchGridInternalPartial', userSearchGridInternalPartial);
		Handlebars.registerPartial('userSearchGridExternalPartial', userSearchGridExternalPartial);
		Handlebars.registerPartial('userSearchGridGenericPartial', userSearchGridGenericPartial);
		Handlebars.registerPartial('connectButtonPartial', connectButtonPartial);
		Handlebars.registerPartial('sendMessageButtonPartial', sendMessageButtonPartial);
		Handlebars.registerPartial('userSearchGridNoResultsPartial', userSearchGridNoResultsPartial);
		Handlebars.registerPartial('sendReferralButtonPartial', sendReferralButtonPartial);
		Handlebars.registerPartial('userSearchfeaturedpremiumPartial', userSearchfeaturedpremiumPartial);

		return Handlebars.compile(userSearchGridTemplate);
	});
